// extracted by mini-css-extract-plugin
export default {"indicatorStats":"b5M9l4YIT6sFxGZj8B9O"};